import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';

const DOROPARTY_ORIGIN = 'https://doroparty.com';

function requireSupabaseClient() {
  if (!hasSupabaseConfig || !supabase) {
    throw new Error('Supabase 환경 변수가 설정되지 않았습니다.');
  }

  return supabase;
}

function normalizeEmail(email) {
  return String(email || '').trim().toLowerCase();
}

export async function signUpWithEmail({ email, password }) {
  const client = requireSupabaseClient();
  const emailRedirectTo = `${DOROPARTY_ORIGIN}/`;

  const { data, error } = await client.auth.signUp({
    email: normalizeEmail(email),
    password,
    options: {
      emailRedirectTo,
    },
  });

  if (error) throw error;
  return data;
}

export async function signInWithEmail({ email, password }) {
  const client = requireSupabaseClient();
  const { data, error } = await client.auth.signInWithPassword({
    email: normalizeEmail(email),
    password,
  });

  if (error) throw error;
  return data;
}

export async function requestPasswordReset(email) {
  const client = requireSupabaseClient();
  const redirectTo = `${DOROPARTY_ORIGIN}/?mode=reset-password`;
  const { data, error } = await client.auth.resetPasswordForEmail(normalizeEmail(email), {
    redirectTo,
  });

  if (error) throw error;
  return data;
}

export async function updateRecoveredPassword(password) {
  const client = requireSupabaseClient();
  const { data, error } = await client.auth.updateUser({ password });

  if (error) throw error;
  return data;
}

export async function signOutCurrentSession() {
  const client = requireSupabaseClient();
  const { error } = await client.auth.signOut();
  if (error) throw error;
}

export function getAuthErrorMessage(error) {
  const message = String(error?.message || error || '인증 처리 중 오류가 발생했습니다.');

  if (/invalid login credentials/i.test(message)) return '이메일 또는 비밀번호가 올바르지 않습니다.';
  if (/email not confirmed/i.test(message)) return '인증메일에서 이메일 확인을 먼저 완료해주세요.';
  if (/user already registered/i.test(message)) return '이미 가입된 이메일입니다.';
  if (/password should be at least/i.test(message)) return '비밀번호는 8자 이상 입력해주세요.';
  if (/same password/i.test(message)) return '기존 비밀번호와 다른 비밀번호를 입력해주세요.';
  if (/expired|invalid.*token|otp/i.test(message)) return '재설정 링크가 만료되었거나 올바르지 않습니다.';
  if (/signup is disabled/i.test(message)) return '현재 신규 가입이 비활성화되어 있습니다.';
  if (/rate limit/i.test(message)) return '요청이 너무 많습니다. 잠시 후 다시 시도해주세요.';
  if (/supabase 환경 변수/i.test(message)) return message;

  return message;
}
